import React from 'react';
import * as Icon from 'react-feather';
import { useAppDispatch } from '../hooks/redux';

import {
    Button as AlchemyButton,
} from "@amzn/alchemy-components-react";

import { showModal } from '../slices/feedbackModalSlice';
import i18n from "../i18n";
import {bugReport, featureRequest, productWiki, shoutoutsLink} from "../utils"
import LanguageSelector from "./LanguageSelector";

export default function() {
    const dispatch = useAppDispatch();
    function handleFeedbackClick() {
        console.log('handleFeedbackClick trigger')

        dispatch(showModal(true))
    }
    return (
        <footer className="alchemy-footer d-flex justify-content-between">
            <div className="d-flex">
                <div className="footer-language">
                    <LanguageSelector />
                </div>
                <a href={bugReport}
                    className="footer-link"
                    target="_blank" rel="noopener noreferrer">
                    <strong>{i18n.t('footer:report-bug')}</strong>
                </a>
                <a href={featureRequest}
                    className="footer-link"
                    target="_blank" rel="noopener noreferrer">
                    <strong>{i18n.t('footer:feature-request')}</strong>
                </a>
                <a href={productWiki}
                    className="footer-link"
                    target="_blank" rel="noopener noreferrer">
                    <strong>{i18n.t('footer:wiki')}</strong>
                </a>
                <div onClick={handleFeedbackClick} className="footer-feedback">
                    <AlchemyButton className="button-transparent" size="sm">
                        <img style={{"height": "14px"}} src='/resources/img/thumbs-up.svg' />
                        <img style={{"height": "14px"}} src='/resources/img/thumbs-down.svg' />
                    </AlchemyButton>
                </div>
            </div>
            <div>
                {i18n.t('footer:maintained-by')}:&nbsp;
                <a href={shoutoutsLink}
                    className="no-link-style link-team"
                    target="_blank" rel="noopener noreferrer">
                     longzhiw@
                </a>
            </div>
        </footer>
    );
}
